import React from 'react'
import MarkdownRenderer from '../../components/MarkdownRenderer';

const ExampleList =  (props) => {

  return(
    <React.Fragment>
      {props.title ? (<h3>{props.title}</h3>) : null}
      {props.body? (<p>{props.body}</p>) : null}
      <ul className="bulleted">
        {props.list.map((listItem, index, array) => (
          <li key={index + listItem.text}>
            {listItem.text}:{' '}
            <MarkdownRenderer text={listItem.markdown} inline={true}/>
            {listItem.helper ? (<span className="text-italic">{` ${listItem.helper}`}</span>) : null}
          </li>
        ))}
      </ul>
    </React.Fragment>
  )
}

export default ExampleList



// WEBPACK FOOTER //
// ./src/components/ExampleList/index.js